module.exports = __webpack_public_path__ + "img/banner2023.95952847.jpeg";